export default __webpack_public_path__ + "static/media/VerifiedBlueLogoMark.db04d41d.svg";